<script lang="ts">
  import { APP_NAME, SITE_ENABLED } from "../../lib/brand";
  import { go } from "../../lib/router.svelte";
</script>

{#if SITE_ENABLED}
  <section class="max-w-4xl mx-auto px-6 py-24 text-center">
    <h1 class="text-5xl font-bold tracking-tight leading-tight">
      Trusted Intelligent Operations
    </h1>
    <p class="mt-6 text-lg text-slate-400 max-w-2xl mx-auto">
      {APP_NAME} is the AI operator for the enterprise — it connects to your systems, runs
      tools safely, and keeps context across your work. Start free, scale to remote
      control, memory, and advanced workflows.
    </p>
    <div class="mt-10 flex items-center justify-center gap-4">
      <a
        href="/download"
        onclick={(e) => go(e, "/download")}
        class="px-5 py-3 rounded-md bg-indigo-500 hover:bg-indigo-400 text-white font-medium"
      >
        Download {APP_NAME}
      </a>
    </div>
  </section>
{:else}
  <!-- On-prem (Neos Hub): no marketing/download. Point operators straight at
       the surfaces that exist here — remote control (and the admin console,
       which is reachable from the identity menu for admins). -->
  <section class="max-w-2xl mx-auto px-6 py-28 text-center">
    <h1 class="text-4xl font-bold tracking-tight">{APP_NAME} Hub</h1>
    <p class="mt-5 text-lg text-slate-400">
      Sign in to drive your agents remotely or manage the deployment.
    </p>
    <div class="mt-10 flex items-center justify-center gap-4">
      <a
        href="/remote"
        onclick={(e) => go(e, "/remote")}
        class="px-5 py-3 rounded-md bg-indigo-500 hover:bg-indigo-400 text-white font-medium"
      >
        Open Remote Control
      </a>
    </div>
  </section>
{/if}
